// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.cards-title[data-v-c9043a64]{margin-bottom:2.4rem}.cards-title[data-v-c9043a64],.text-title[data-v-c9043a64]{color:var(--text-primary)}.text-title[data-v-c9043a64]{margin-top:4.8rem;margin-bottom:1.6rem}@media (max-width:767px){.text-title[data-v-c9043a64]{margin-top:3.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
